<template>
  <div class="company-contain">
    <div v-show="loading" class="page-loading" style="width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px;">
      <div class="loading-box" style="box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%);">
        <div class="loading-img"></div>
      </div>
    </div>

    <div class="search-company-box">  
      <div class="Quarterly-Report" v-if="allDateTyps.length > 0">
        <div class="head-title" @click.stop="showDateDropmemu($event)">
          {{ curDateTyp }}
          <span class="close-bot" @click.stop="showDateDropmemu($event)"></span>
        </div>
        <ul class="menu-lanmu" v-show="dateDropmenu">  
          <li v-for="h in allDateTyps">
            <a href="javascript:;" v-if="curDateTyp != h" @click="clickDropmenu(), curDateTyp = h, tableFilter()">{{ h }}</a>
          </li>
        </ul>
      </div> 

      <!-- 高管 -->
      <div class="dhy-details-box" v-if="gaoguan.length > 0"> 
        <h3 class="">高管介绍</h3>
        <div class="cop-list-main"> 
          <ul class="cop-list-box" v-for="(index, h) in gaoguan" track-by="$index" v-show="index >= ((page-1)*10) && index < (page*10)">
            <li><p class="date">姓名</p> <p class="time">{{ h.name }}</p></li>
            <li><p class="date">年龄</p> <p class="time">{{ h.age }}</p></li>
            <li><p class="date">性别</p> <p class="time">{{ h.gender }}</p></li>
            <li><p class="date">职务</p> <p class="time">{{ h.job }}</p></li> 
            <li><p class="date">持股数</p> <p class="time">{{ h.holdshare }}</p></li>  
          </ul> 
        </div>

        <div class="cop-pledge-page"> 
          <span class="Previous-page" v-if="page > 1" @click="page--">上一页</span>
          <span class="menu-page"><span style="color: #3270ad">{{ page }}</span>/{{ totalPage }} </span>
          <span class="lower-page" v-if="page < totalPage" @click="page++">下一页</span> 
        </div>  
      </div><!-- /高管 -->
    </div>

    <!-- 相关公告 -->
    <div class="search-result-box announ-zy" v-if="notice.lists.length > 0">
      <h3 class="">相关公告</h3>
      <div class="search-result-list" v-for="h in notice.lists"> 
        <p class="head"> 
         <span class="dov-icon"></span><a href="javascript:;" @click="goNotice(h)">{{ h.title }}</a>  
        </p>
        <p class="Subtitle"><span class="fl">证券代码：{{ companycode }}</span><span class="fr">{{ h.publishDate }}</span></p>
      </div>

      <div class="cop-pledge-page"> 
        <span class="Previous-page" v-if="notice.page > 1" @click="notice.page--, getRelationNotice()">上一页</span>
        <span class="menu-page"><span style="color: #3270ad">{{ notice.page }}</span>/ {{ notice.totalPage }} </span>
        <span class="lower-page" v-if="notice.page < notice.totalPage" @click="notice.page++, getRelationNotice()">下一页</span> 
      </div>  
    </div><!-- /相关公告 -->
  </div>

  <!--微信绑定弹框-->
  <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" v-show="tipGoBind">
    <div class="binding-content">
      <a class="binding-logo"></a>
      <div class="binding-text">
        立即绑定IBDATA账号<br/>成为金融分析高手
      </div>
      <div class="binding-bot">
        <a class="binding-no-btn" @click="tipGoBind = false">暂不绑定</a>
        <a class="binding-btn" @click="goBindPage">立即绑定</a>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade in" v-show="tipGoBind"></div>
  <!-- / 微信绑定弹框-->
</template>

<script>
  import { alert, apiUrl, downloadURL } from '../../helper'
  import $ from 'jquery'
  import userMix from '../../common/userMix'
  import searchMix from '../../common/searchMix'
  import comSearchMix from '../../common/comSearchMix'
  import companyMix from '../../common/companyMix'
  import wxshareMix from '../../common/wxshareMix'

  export default {
    name: 'GaoGuan',
    mixins: [userMix, searchMix, comSearchMix, companyMix, wxshareMix],
    data () {
      return {
        gaoguan: [],
        originData: [],
        allDateTyps: [],
        curDateTyp: '',
        page: 1,
        perPage: 10,
        total: 0,
        totalPage: 0,
        notice: {
          lists: [],
          page: 1,
          perPage: 10,
          total: 0,
          totalPage: 0,
          pageInfo: {},
        }
      }
    },
    route: {
      data({to}) {
        if (!this.currentuser) {
          this.wxcode = this.getQueryString('code')  // 获取微信登录code
          if (this.wxcode) {
            this.wxlogin(this.wxcode)
          } else {
            this.getProfile(to.query.share)
          }
        }

        if (this.currentuser) { 
          this.queryParam = to.query;
          this.companycode = to.query.companycode;
          this.stype = to.query.stype;

          // 微信签名 分享
          let title = decodeURIComponent(to.query.desc);
          let desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！成功跳转到公司高管信息页面';
          document.title = title;
          this.getwxsign()    // 微信签名
          this.shareCompany(title, desc);
          
          this.setSelectedTab();
          this.getGaoguan();
          this.getRelationNotice();
        }
      }
    },
    methods: {
      // 高管
      getGaoguan: function() {
        this.loading = true;
        
        let query = {};
        query.code = this.companycode;
        query.uid = parseInt(this.queryParam.uid)
        query.ruid = parseInt(this.queryParam.ruid)
        query.share = this.queryParam.share
        query.plat = this.queryParam.plat
        query.sid = this.queryParam.sid

        $.ajax({
          url: apiUrl('/V1.0.0/company/executivehist'),
          method: 'post',
          dataType: 'json',
          // data: JSON.stringify({'code': this.companycode})
          data: JSON.stringify(query)
        }).done((response) => {
        
          if (response.status === 0) {
            this.gaoguan = response.data;
            this.originData = response.data;
            this.total = response.data.length;
            this.totalPage = Math.ceil(this.total / this.perPage);

            this.gaoguan.sort((a, b) => {
              return Date.parse(b.updtime) - Date.parse(a.updtime);
            });

            let tmp = {};
            let year = '';
            let month = '';
            let str = '';
            for (let h of response.data) {
              str = '';
              year = '';
              month = '';

              year = h.updtime.split('-')[0];
              month = parseInt( h.updtime.split('-')[1] );

              if (month >= 4 && month < 7) {
                str = year + '年一季报';
              } else if (month >= 7 && month < 10) {
                str = year + '年半年报';
              } else if (month >= 10 && month <12){
                str = year + '年三季报';
              } else if (month == 12 || (month >=1 && month < 4)) {
                str = (year - 1) + '年年报';
              }

              if (!tmp[str]) {
                tmp[str] = true;
                this.allDateTyps.push(str);
              }
            }

            this.curDateTyp = this.allDateTyps[0];
            this.tableFilter();
            this.loading = false;
          } else {
            alert(response.description)
          }

        }).fail((response) => {
          this.loading = false;
          alert('请求失败')
        })
      },

      // 高管 筛选
      tableFilter: function() {
        let startdate = '';
        let enddate = '';

        let year = parseInt( this.curDateTyp.split('年')[0] );
        if (this.curDateTyp.indexOf('一') > 0) {
          startdate = year + '-' + '04-01';
          enddate = year + '-' + '06-31';
        } else if (this.curDateTyp.indexOf('半') > 0) {
          startdate = year + '-' + '07-01';
          enddate = year + '-' + '09-31';
        } else if (this.curDateTyp.indexOf('三') > 0) {
          startdate = year + '-' + '10-01';
          enddate = year + '-' + '12-31';
        } else if (this.curDateTyp.indexOf('年年') > 0) {
          startdate = (year + 1) + '-' + '01-01';
          enddate = (year + 1) + '-' + '03-31';
        }

        let arr = [];
        for (let h of this.originData) {
          if (h.updtime >= startdate && h.updtime <= enddate) {
            arr.push(h);
          }
        }

        this.gaoguan = arr;
        this.page = 1;
        this.total = this.gaoguan.length;
        this.totalPage = Math.ceil(this.total / this.perPage);
        console.log(this.gaoguan.length);
      },
      
      // 相关公告
      getRelationNotice: function() {
        
        this.loading = true;
        this.notice.pageInfo.page = this.notice.page;
        this.notice.pageInfo.perPage = this.notice.perPage;
        this.notice.pageInfo.code = this.companycode;

        $.ajax({
          url: apiUrl('/V1.0.0/company/executivenotice'),
          method: 'post',
          dataType: 'json',
          data: JSON.stringify(this.notice.pageInfo)
        }).done((response) => {

          this.loading = false;
          if (response.status === 0) {
            this.notice.lists = response.data.lists;
            this.notice.total = response.data.total;
            this.notice.totalPage = Math.ceil(response.data.total / this.notice.perPage);
          } else {
            alert(response.description)
          }

        }).fail((response) => {
          this.loading = false;
          alert('请求失败')
        })
      },

      // 公告详情
      goNotice: function (item) {
        let query = {};
        query.pdate = item.publishDate;
        query.k = item.id;
        query.t = 1;

        this.$route.router.go({ path: '/notice/detail', query: query })
      },
    }
  }
</script>

<style scoped>
  /*加载*/
  .loading-box {
    top: 43% !important;
  }
  .loading-img {
    width: 35px;
    height: 35px;
    background-image: url('../../../static/images/loading2.gif');
    background-size: cover;
  }

  .Quarterly-Report .head-title {
    display: block;
  }

</style>




/** WEBPACK FOOTER **
 ** GaoGuan.vue?355c6254
 **/